module.exports = __webpack_public_path__ + "img/lion.1a7be8aa.svg";